import useLiveSource from "@/shared/atoms/useLiveSource";
import { Sources } from "@/shared/utils/enum";
import { asArray } from "@/shared/utils/helpers";
import { OrdersLive } from "@/shared/v2/queries/interfacesV2";
import LiveLanes from "./LiveLanes";
import LiveMap from "./LiveMap";

const LiveOrders = ({ data }: { data: OrdersLive }) => {
  const [source] = useLiveSource();
  return asArray(source).includes(Sources.QR) ? (
    <LiveMap data={data} />
  ) : (
    <LiveLanes data={data} />
  );
};

export default LiveOrders;
